import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftLarge = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M5.28125 10.3125L11.2812 4.3125C11.6562 3.90625 12.3125 3.90625 12.6875 4.3125C13.0938 4.6875 13.0938 5.34375 12.6875 5.71875L7.40625 11L12.6875 16.3125C13.0938 16.6875 13.0938 17.3438 12.6875 17.7188C12.3125 18.125 11.6562 18.125 11.2812 17.7188L5.28125 11.7188C4.875 11.3438 4.875 10.6875 5.28125 10.3125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowLeftLarge);
export default ForwardRef;
